import React, {useEffect} from "react";
import {chartColors} from "../AppConstants";

import Chart from "react-apexcharts";
import {formattingMoney, formattingPercent} from "./utils/formatting";
import {map_for_pie} from "./utils/mapping"

export default function PiePortfolio(props) {
    //let chartInstance = null;
    const portfolio=props.portfolio
    const currency =props.currency
    const {list, list_title} = map_for_pie(portfolio)
    const options = {
        tooltip: {
            enabled: true,
            fillSeriesColor: false,
            theme: 'light',
            y: {
                title: {
                    formatter: function (seriesName) {
                        return seriesName + '<br>'
                    }
                },
                formatter: function (val) {
                    var percent = "";
                    var total = portfolio.balance
                    if (total > 0) {
                        percent = "<br>"+ formattingPercent(val / total * 100) + " %";
                    }
                    return `${formattingMoney(val)} ${currency} ${percent}`
                },
            }
        },
        colors: chartColors,
        labels: list_title,

        dataLabels: {
            enabled: false,
            // formatter: function (val) {
            //     return val + "%"
            // },
        },

        legend: {
            show: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['#FFFFFF'],
        },
        plotOptions: {
            pie: {
                expandOnClick: false,
                donut: {
                    size: '65%',
                    labels: {
                        show: true,
                        name: {
                            show: false
                        },
                        total: {
                            show: true,
                            showAlways: true,
                            offsetY: -10,
                            fontSize: '20px',
                            fontFamily: '"Space Grotesk", sans-serif',
                            fontWeight: 600,
                            color: '#0B1426',
                            formatter() {
                                return 'Все активы'
                            }
                        }
                    },
                },
            }
        }

    }
    return (
        <Chart options={options} series={list} type="donut" width="300" height="300"/>
    );
}
